// Wrapper for mocking in tests
export default function getLocation() {
  return window.location;
}
